import { useMemo } from "react";
import { calculate, type CalcContext, type CalcResult } from "@h2lca/core";
import { useMaster } from "./master";
import { useWorkshop } from "./workshop";

/**
 * 현재 시나리오의 계산 결과 , 입력이 바뀌면 즉시 다시 계산된다(과업지시서: 값 변경 시 결과 즉시 갱신).
 * 셀렉터는 저장소의 객체를 그대로 돌려줘야 한다 , 매번 새 객체를 만들면 zustand 가 변경으로 보고 무한 갱신에 빠진다.
 */
export function useCalcContext(): CalcContext {
  const data = useMaster((s) => s.data);
  return useMemo(() => ({ factors: data.factors, sources: data.sources, methods: data.methods }), [data]);
}

export function useResult(): CalcResult | null {
  const scenario = useWorkshop((s) => s.scenario);
  const ctx = useCalcContext();
  return useMemo(() => (scenario ? calculate(scenario, ctx) : null), [scenario, ctx]);
}
